<section class="mb-4">
  <nz-search-input
    [searchValue]="searchValue"
    (onSearchValueChange)="onSearch($event)"
    placeholder="Търсене на потребители...">
  </nz-search-input>
</section>
<section class="mb-4">
  <nz-search-result
    [totalResults]="this.totalResults"
    [sortOptions]="sortOptions"
    [selectedSortOption]="selectedSortOption"
    (onSortOptionChange)="onSort($event)">
  </nz-search-result>
</section>
@if (!loading) {
  @if (users.length === 0) {
    <h4 class="my-5 text-muted">
      Няма намерени потребители
    </h4>
  }
  <section>
    <ul class="list-unstyled" nzRestoreScrollPosition>
      @for (user of users; track user.userFollowerId) {
        <li class="my-3 d-flex border shadow bg-white rounded-3">
          <a class="profile-card-image"
             [routerLink]="[appRoutes.root, appRoutes.profile, user.userId]">
            <nz-image [imageUrl]="!!user.userProfileImageId
              ?  environment.apiImageUserProfileUrl + '/' + user.userId + '/' + user.userProfileImageId
              : environment.apiImageDefaultUserProfileUrl"/>
          </a>
          <div class="profile-card-body d-flex flex-column justify-content-between">
            <div class="d-flex justify-content-between">
              <div class="text-truncate">
                <a class="px-2 pb-0 btn btn-link d-block text-truncate text-decoration-none text-start"
                   [routerLink]="[appRoutes.root, appRoutes.profile, user.userId]">
                  {{ user.username }}
                </a>
                <div class="px-2 text-truncate small text-muted">
                  Рейтинг:
                  <nz-user-rating [rating]="user.userRating"/>
                </div>
              </div>
              <div class="dropdown">
                <button type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                        class="btn btn-light text-muted dropdown-button">
                  <i class="fa-solid fa-ellipsis-vertical" aria-hidden="true"></i>
                </button>
                <ul class="dropdown-menu dropdown-menu-end rounded-end-0 shadow">
                  <li>
                    <a class="dropdown-item"
                       [routerLink]="[appRoutes.root, appRoutes.profile, user.userId]">
                      <i class="me-2 text-muted fa-solid fa-eye" aria-hidden="true"></i>
                      Преглед на профила
                    </a>
                  </li>
                  <hr class="dropdown-divider">
                  <li>
                    <button class="dropdown-item"
                            (click)="upsertUserFollower(user)">
                      <i class="me-2 text-muted fa-solid " aria-hidden="true"
                         [ngClass]="!!user.ownUserFollowerId ? 'fa-user-xmark' : 'fa-user-check'"></i>
                      {{ !!user.ownUserFollowerId ? 'Спри да следваш' : 'Започни да следваш' }}
                    </button>
                  </li>
                </ul>
              </div>
            </div>
            <small class="p-2 pt-0 text-end text-muted">
              {{ user.dateTime | date: 'dd:MM:yyyy г., HH:mm ч.' }}
            </small>
          </div>
        </li>
      }
    </ul>
  </section>
} @else {
  <section class="my-5">
    <div class="text-center">
      <h1>
        <i class="text-dark fa-solid fa-spinner fa-spin"></i>
      </h1>
      <h5 class="text-muted">Зареждане...</h5>
    </div>
  </section>
}
@if (this.totalResults > defaultPageLimit) {
  <section class="py-4">
    <nz-pagination
      [totalResults]="totalResults"
      [selectedPage]="selectedPage"
      [selectedPageLimitOptionId]="selectedPageLimitOptionId"/>
  </section>
}
